import { render, staticRenderFns } from "./remote_nav.vue?vue&type=template&id=67ff88fe&scoped=true"
import script from "./remote_nav.vue?vue&type=script&lang=js"
export * from "./remote_nav.vue?vue&type=script&lang=js"
import style0 from "./remote_nav.vue?vue&type=style&index=0&id=67ff88fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ff88fe",
  null
  
)

export default component.exports